import { create } from 'zustand';
import { TicketData } from '../models/Ticket';

/**
 * Store global para gestión de tickets
 * Similar a un Service en Angular
 */
interface TicketStore {
  // Estado
  selectedTicket: TicketData | null;
  myTicketsInitialTab: 'active' | 'history';
  
  // Actions
  setSelectedTicket: (ticket: TicketData | null) => void;
  setMyTicketsInitialTab: (tab: 'active' | 'history') => void;
}

export const useTicketStore = create<TicketStore>((set) => ({
  // Estado inicial
  selectedTicket: null,
  myTicketsInitialTab: 'active',

  // Acciones
  setSelectedTicket: (ticket) => set({ selectedTicket: ticket }),
  
  setMyTicketsInitialTab: (tab) => set({ myTicketsInitialTab: tab }),
}));
